import { LoadingRegion } from "@/components/skeletons";
import { Skeleton } from "@/components/ui/skeleton";
import { repeat } from "@/lib/utils";

/** Mirrors the room: header, a few seats around the table, and the card row. */
export function RoomSkeleton() {
  return (
    <LoadingRegion testId="room-loading" className="flex min-h-screen flex-col">
      <div className="flex items-center justify-between border-b border-border/50 bg-card/50 px-4 py-3">
        <div className="flex items-center gap-3">
          <Skeleton className="size-8" />
          <Skeleton className="h-4 w-40" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-20" />
        </div>
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-6 p-4">
        <div className="flex gap-4">
          {repeat(2, (index) => (
            <Skeleton key={index} className="h-20 w-14 rounded-lg" />
          ))}
        </div>
        <Skeleton className="h-[140px] w-full max-w-xl rounded-2xl" />
        <div className="flex gap-4">
          <Skeleton className="h-20 w-14 rounded-lg" />
        </div>
      </div>
      <div className="flex flex-wrap justify-center gap-2 border-t border-border/50 bg-card/50 px-4 py-4">
        {repeat(10, (index) => (
          <Skeleton key={index} className="h-16 w-12 rounded-lg sm:h-20 sm:w-14" />
        ))}
      </div>
    </LoadingRegion>
  );
}
